import React, { useContext } from "react";
import { CareRecipientListContext } from "../../../provider/CareRecipientListProvider";
import { Paginate } from "../../common/button/paginate/Paginate";

export const CareRecipientListPaginate = React.memo(function CareRecipientListPaginate() {
    const {
        countPerPage,
        currentPage,
        setCurrentPage,
        searchedList
    } = useContext(CareRecipientListContext);

    const renderPaginate = searchedList.length > countPerPage;

    return renderPaginate ? (
        <div className="paginate_button_area">
            <Paginate
                currentPage={currentPage} 
                onPageChange={(page: number) => setCurrentPage(page)} 
                pageCount={!searchedList ? 0 : Math.ceil(searchedList.length / countPerPage)}
            />
        </div>
    ) : <></>;
});
